<template>
  <div class="page-wrap">
    <el-card shadow="never">
      <div class="toolbar">
        <el-input v-model="query.applyNo" placeholder="会员编号" style="width:220px;margin-right:12px" clearable />
        <el-select v-model="query.merchantType" placeholder="会员类型" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in merchantTypeOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
        <el-select v-model="query.merchantProperties" placeholder="申请类型" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in merchantPropertiesOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
        <el-select v-model="query.status" placeholder="状态" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
        <el-select v-model="query.bankStatus" placeholder="银行状态" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
        <el-select v-model="query.storeId" filterable placeholder="门店" clearable style="width:220px;margin-right:12px">
          <el-option v-for="opt in storeList" :key="opt.id" :label="opt.storename" :value="opt.id" />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="fetchList">查询</el-button>
        <el-button type="success" icon="el-icon-plus" style="margin-left:auto" @click="goCreate" v-permission="'menu:finance:bf:operator'">新增开户</el-button>
        <el-button type="warning" icon="el-icon-plus" style="margin-left:auto" @click="goCreatePl" v-permission="'menu:finance:bf:operator'">批量开户</el-button>
      </div>
      <el-table :data="list" border stripe v-loading="loading" style="width:100%">
        <el-table-column prop="applyNo" label="申请编号" width="300"/>
        <el-table-column prop="uid" label="会员编号" width="200"/>
        <el-table-column label="门店名称" prop="storeName"/>
        <el-table-column prop="merchantType" label="会员类型" width="120">
          <template slot-scope="{row}">{{ dictLabel(merchantTypeOptions,row.merchantType) }}</template>
        </el-table-column>
        <el-table-column prop="merchantProperties" label="申请类型" width="140">
          <template slot-scope="{row}">{{ dictLabel(merchantPropertiesOptions,row.merchantProperties) }}</template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="{row}">{{ dictLabel(statusOptions,row.status) }}</template>
        </el-table-column>
        <el-table-column label="原因" prop="error"/>
        <el-table-column label="银行开户状态">
          <template slot-scope="{row}">{{ dictLabel(statusOptions,row.bankStatus) }}</template>
        </el-table-column>
        <el-table-column label="银行类型">
          <template slot-scope="{row}">{{ dictLabel(bankTypeOptions,row.bankType) }}</template>
        </el-table-column>
        <el-table-column label="银行账户号" prop="bankAccountNo"/>
        <el-table-column label="银行收款账户" prop="relAccountNo"/>
        <el-table-column label="ACS账户号" prop="acsAccountNo"/>
        <el-table-column label="账户余额" prop="balance"/>
        <el-table-column label="创建时间" prop="createTime" width="180"/>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text"  v-permission="'menu:finance:bf:operator'" @click="goBankOpen(row)" v-if="row.status === '1' && (!row.bankStatus || row.bankStatus == '2')">银行开户</el-button>
            <el-divider direction="vertical" v-if="row.status === '1' && (!row.bankStatus || row.bankStatus == '2')"></el-divider>
            <el-button type="text"  v-permission="'menu:finance:bf:operator'" @click="goEdit(row)">编辑</el-button>
            <el-divider direction="vertical" v-if="row.status == '2'"></el-divider>
            <el-button type="text"  v-permission="'menu:finance:bf:operator'" @click="goRestartEdit(row)">重新开户</el-button>
            <el-divider direction="vertical" v-if="row.bankStatus == '1'"></el-divider>
            <el-button type="text"  v-permission="'menu:finance:bf:operator'" @click="gwOpen(row)" v-if="row.bankStatus == '1'">挂网补传</el-button>
            <!--            <el-popconfirm title="确认删除该记录吗？" v-permission="'menu:finance:bf:delete'" @confirm="handleDelete(row)" v-if="row.isDelete == '1'">-->
<!--              <el-button type="text" slot="reference" style="color:#f56c6c">删除</el-button>-->
<!--            </el-popconfirm>-->
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination
            background
            layout="total, prev, pager, next, sizes"
            :total="total"
            :current-page.sync="query.page"
            :page-size.sync="query.pageSize"
            :page-sizes="[10,20,50,100]"
            @current-change="fetchList"
            @size-change="fetchList"
        />
      </div>
    </el-card>

    <el-dialog
        title="批量导入开户"
        :visible.sync="dialogVisible">
      <el-upload
          ref="imgBroadcastUpload"
          :limit="1"
          :auto-upload="true"
          :file-list="fileList"
          :on-success="addPic"
          accept="xlsx/xls"
          :action="uploadurl">
        <i class="el-icon-plus"></i>
        <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件，且不超过2M</div>
      </el-upload>
    </el-dialog>

    <el-dialog
        title="补传挂网协议"
        :visible.sync="gwDialogVisible">
      <div class="agreeContainer">
        <el-checkbox v-model="htAgreeFlag" @change="handleSelectedAgree"></el-checkbox>
        <a style="flex: 1; color: deepskyblue; font-size: 15px; margin-left: 5px" @click="handleClickAgree">华通银行“e账户”注册会员号管理协议</a>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="gwDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitGw">确定</el-button>
      </span>
    </el-dialog>

    <!-- 预览弹窗 -->
    <el-dialog title="华通银行“e账户”注册会员号管理协议" @close="handleCloseLookAgree" :visible.sync="lookAgreeVisiable" fullscreen>
      <!-- 这里渲染转换后的 HTML -->
      <div v-html="htmlContent" class="word-content"></div>
    </el-dialog>
  </div>
</template>

<script>
// 说明：接口路径与后端保持一致，下面以 /api/open-account 为示例
import axios from 'axios'
import mammoth from "mammoth";
export default {
  name: 'OpenAccountList',
  data(){
    return {
      uploadurl: this.GLOBAL.imgURL+'open-account/createBankAccountPl',
      fileList: [],
      gwDialogVisible:false,
      lookAgreeVisiable:false,
      htAgreeFlag:false,
      lookAgree: false,
      htmlContent: null,
      dialogVisible:false,
      loading:false,
      list:[],
      storeList:[],
      total:0,
      query:{
        page:1,
        pageSize:10,
        applyNo:'',
        merchantType:'',
        merchantProperties:'',
        status:'',
        bankStatus:'',
        storeId: null
      },
      merchantTypeOptions:[
        {label:'个体商户', value:'INDIVIDUAL'},
        {label:'企业商户', value:'COMPANY'}
      ],
      merchantPropertiesOptions:[
        {label:'普通商户', value:'AGENT_MEMBER'},
        {label:'代理商', value:'AGENT_BRANCH'}
      ],
      statusOptions:[
        {label:'审核中', value:'0'},
        {label:'审核成功', value:'1'},
        {label:'审核失败', value:'2'}
      ],
      bankTypeOptions: [
        { label: '苏商企业号', value: 'SSQY-MC' },
        { label: '华通银行', value: 'HT-MC' },
      ],
      gwForm: {}
    }
  },
  created(){
    this.fetchList();
    this.getList();
  },
  methods:{
    dictLabel(arr,val){
      const f=arr.find(i=>i.value===val);
      return f?f.label:val||'-'
    },
    async getList(){
      const { data:res } = await this.$http.get('open-account/getStoresAll/')
      this.storeList = res.data
      this.storeList.push({id: '-1', storename: '公司账户'})
    },
    async fetchList(){
      this.loading=true
      try{
        const {data} = await axios.post('/open-account/list/',this.query)
        if(data.code == 200){
          this.list=data.data.list||[]
          this.total=data.data.total||0
        }else{ this.$message.error(data.msg||'查询失败') }
      }catch(e){ this.$message.error('查询异常'); console.error(e) }
      finally{ this.loading=false }
    },
    async goCreate(){
      this.$router.push({ path:'openBfAccountOperator', query:{ mode:'create', restart: false, isDelete: false } })
    },
    async goCreatePl(){
      this.fileList = []
      this.dialogVisible = true
    },
    goBankOpen(row){ this.$router.push({ path:'openBankForm', query:{ uid: row.uid, lx: row.merchantType, name: row.customerName, id: row.id } }) },
    goEdit(row, flag){
      this.$router.push({ path:'openBfAccountOperator', query:{ mode:'edit', id: row.id, flag, restart: row.status == '2', isDelete: row.isDelete == '1' } })
    },
    goRestartEdit(row, flag){
      this.$router.push({ path:'openBfAccountOperator', query:{ mode:'edit', id: row.id, flag, restart: true, isDelete: true } })
    },
    gwOpen(row){
      this.gwDialogVisible = true
      this.lookAgreeVisiable =false
      this.htAgreeFlag = false
      this.lookAgree = false
      this.htmlContent = null
      this.gwForm = {
        uid: row.uid,
        balanceAcctId: row.bankAccountNo,
        accountName: row.customerName,
        bankType: row.bankType,
        entryTime: null,
        readingDuration: null,
        checkboxClickTime: null
      }
    },
    async handleDelete(row){
      console.log("=============sdfsdfdsf")
      try{
        const {data:res}=await axios.delete('/open-account/'+row.id)
        if(res && res.code==200){ this.$message.success('删除成功'); await this.fetchList() }
        else{ this.$message.error(res.msg||'删除失败') }
      }catch(e){ this.$message.error('删除异常'); console.error(e) }
    },
    addPic(file){
      console.log("===导入返回值")
      console.log(file)
      if (file.data.code == '0') {
        this.$message.success('导入成功');
        this.dialogVisible = false
      } else {
        if (file.data.error) {
          this.$message.error(file.data.error);
        } else {
          this.$message.error('导入失败');
        }
      }
    },
    handleSelectedAgree(val) {
      if (val && !this.lookAgree) {
        this.$message.error('请先阅读华通银行“e账户”注册会员号管理协议！')
        this.htAgreeFlag = false
      }
      if (val) {
        this.gwForm.checkboxClickTime = new Date();
      }
    },
    handleCloseLookAgree() {
      let closeDate = new Date();
      // 2. 获取毫秒差
      let diffMs = closeDate.getTime() - this.gwForm.entryTime.getTime();

      // 3. 转换为秒 (可以使用 Math.abs 取绝对值，确保为正数)
      this.gwForm.readingDuration = Math.floor(Math.abs(diffMs / 1000));

      this.lookAgree = true
    },
    handleClickAgree() {
      this.lookAgreeVisiable = true

      // 使用 fetch 获取文件流
      fetch('/agree.docx')
          .then(response => response.arrayBuffer())
          .then(arrayBuffer => {
            // 使用 mammoth 转换
            return mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
          })
          .then(result => {
            this.htmlContent = result.value; // 转换后的 HTML
            this.gwForm.entryTime = new Date();
            // result.messages 包含警告信息
          })
          .catch(err => {
            console.error("转换失败", err);
            this.$message.error("协议加载失败");
          });
    },
    submitGw() {
      if (this.htAgreeFlag) {
        // 提交数据：在此处调用 API
        axios.post('/open-account/uploadGwAgree', this.gwForm)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success('挂网成功')
                this.gwDialogVisible = false
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => this.$message.error('挂网失败'))
      } else {
        this.$message.error('未同意华通银行证明无法保存')
      }
    }
  }
}
</script>

<style scoped>
.page-wrap{ padding:12px }
.toolbar{ display:flex; align-items:center; margin-bottom:12px }
.pager{ margin-top:12px; text-align:right }

.agreeContainer{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.word-content {
  overflow-y: auto;
  border: 1px solid #eee;
  padding: 20px;
}
</style>
